<template>
  <q-layout view="hHh lpR fFf">
    <q-header>
      <Header />
    </q-header>
    <q-page-container>
      <router-view v-slot="{ Component }">
        <suspense timeout="0">
          <template #default>
            <component :is="Component" />
          </template>
          <template #fallback>
            <Loading />
          </template>
        </suspense>
      </router-view>
    </q-page-container>
    <q-footer>
      <div class='row no-wrap'>
        <div :class='"col offset-sm-2" + ($q.screen.lt.sm ? " text-left q-ml-xs"  : "")'>
          © {{ currentYear }} DigiPen, All Rights Reserved.
        </div>
        <div class='col-2 q-mr-xs text-right'>v{{version}}</div>
      </div>
    </q-footer>
  </q-layout>
</template>

<script>
import { defineComponent } from 'vue';
import pkg from '../package.json';
import Header from './components/Header.vue';
import Loading from './components/Utilities/Loading.vue';

export default defineComponent({
  name: 'App',
  data() {
    return {
      version: pkg.version,
      currentYear: new Date().getFullYear(),
    };
  },
  components: {
    Header,
    Loading,
  },
});
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

body {
  overflow-x: hidden;
  width: 100%;
}

fieldset {
  border: 0;
  margin: 0;
  padding: 0;
}

.hover-over {
  cursor: pointer;
}

input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type="number"] {
  -moz-appearance: textfield;
}
</style>

<style lang="sass">
.menu-link
  color: white
  background: #F9E3E5
</style>
